import React from "react";
import { Grid2 } from "@mui/material";
import BillingSectionStyles from "./BiliingSectionStyle.module.scss";

function BillingSection(props) {
    const { header, sideButton, sideButtonClick, content } = props; 

    return (
        <div>
            <Grid2 className={BillingSectionStyles.sectionContainer}>
                <Grid2 container direction="column">
                 
                    <Grid2 container justifyContent="space-between" alignItems="center">
                        <Grid2 item className={BillingSectionStyles.header}>
                            {header}
                        </Grid2>
                        <Grid2 item className={BillingSectionStyles.sideButton} onClick={sideButtonClick}>
                            {sideButton}
                        </Grid2>
                    </Grid2>

                    <Grid2 className={BillingSectionStyles.headerLine}></Grid2>

                    <Grid2 container>
                        {content}
                    </Grid2>
                </Grid2>
            </Grid2>
        </div>
    );
}


export default BillingSection;
